/**
 * Shared Ant Design Table defaults for admin dashboard views.
 * @see https://ant.design/components/table — sticky, scroll, pagination, sorter tooltip
 */

/**
 * Sticky header follows the page scroll. We intentionally do NOT set scroll.y here:
 * a fixed body height (e.g. calc(100vh - …)) left a large empty gap under short pages
 * and made the table area feel unstable next to pagination.
 */
export const DASHBOARD_TABLE_STICKY = true;

/**
 * Horizontal scroll only; height follows row count so pagination sits tight under the grid.
 * @param {object} [scrollOverrides] — e.g. { y: 480 } only if you need an inner scroll region
 */
export function dashboardTableScroll(scrollOverrides = {}) {
    return {
        x: 'max-content',
        ...scrollOverrides,
    };
}

/**
 * Question Bank only: fixed table body height so row count / paging does not change the layout height;
 * pagination stays at a stable position below the scroll region.
 * Offset ≈ topbar + content padding + title + segmented + card (tweak if chrome changes).
 */
export const QUESTION_BANK_SCROLL_Y = 'max(280px, calc(100vh - 336px))';

export function questionBankTableScroll() {
    return {
        x: 'max-content',
        y: QUESTION_BANK_SCROLL_Y,
    };
}

/** Master Data (PLITS): table body height — fills viewport under header/filters so less dead space below the pager. */
export const VULNERABILITY_MASTER_SCROLL_Y = 'max(360px, calc(100vh - 300px))';

/**
 * Pagination helpers: jump to page, totals.
 * Rows-per-page dropdown is off by default (was unreliable across these tables).
 * @param {object} base — passed through to Table `pagination` (pageSize, showTotal, etc.)
 */
export function dashboardPagination(base = {}) {
    return {
        /** Required in Ant Design 6 so the bottom pager is always created (avoid [] / none edge cases). */
        placement: ['bottomCenter'],
        showSizeChanger: false,
        showQuickJumper: true,
        size: 'small',
        showLessItems: true,
        ...base,
    };
}

/** Prefer tooltip on the sort icon only (cleaner than full-header tooltips). */
export const DASHBOARD_SORTER_TOOLTIP = { target: 'sorter-icon' };
